'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import a$1 from "../defs/BookmarkSimple.es.js";
const m = a.forwardRef((e, r) => /* @__PURE__ */ a.createElement(p, { ref: r, ...e, weights: a$1 }));
m.displayName = "BookmarkSimpleIcon";
const c = m;
export {
  c as BookmarkSimple,
  m as BookmarkSimpleIcon
};
